import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'
import VueCookies from 'vue-cookies'

// Components
import Login from './views/Login.vue';
import Validate from './views/Validate.vue';
import Nice404 from './views/Nice404.vue';
import UserDetails from './views/UserDetails.vue';
import Announcements from './views/Announcements/Announcements';
import UserDetailsAdmin from './views/UserDetailsAdmin.vue';
import ContactME from "./views/ContactME";
import Logout from "./views/Logout";
import CreateAnnouncement from "./views/Announcements/CreateAnnouncement";
import ShowAdminsDES from "./views/ShowAdminsDES";
import RegisterMe from "./views/RegisterMe";
import RegisterDes from "./views/RegisterDes";
import UserDashboard from "./views/user/UserDashboard.vue";
import ViewAnnouncement from "./views/Announcements/ViewAnnouncement.vue";
import ValidateAnnouncementME from "./views/Announcements/ValidateAnnouncementME.vue";
import ShowAdminsME from "./views/ShowAdminsME";
import Faq from "./views/Faq";
// import ActiveReserve from "./vue/"
import ManageTeams from "./views/ManageTeams";
import CreateTeamView from "./views/CreateTeamView";
import GenerateValidation from "./views/GenerateValidation";
import GenerateEFP from "./views/GenerateEFP";
// import EditHistory from "./views/EditHistory";
import DataPrivacy from "./views/DataPrivacy";
import RegisterSxhmatismos from "./views/RegisterSxhmatismos";
import ShowAdminsDEPS from "./views/ShowAdminsDEPS";
import ValidateAnnouncementDEPS from "./views/Announcements/ValidateAnnouncementDEPS";
import DiavImportView from "./views/DiavImportView";
import AdminDashboard from "@/views/admin/AdminDashboard";
import ΑctiveReserve from "./views/Αctivereserve.vue"
/*import UnverifiedUsers from "./views/UnverifiedUsers";
import EfpUsers from "./views/EfpUsers";*/
import ChangesTable from "./views/ChangesTable";
import ManageSuperAdmins from "@/views/super_admin/ManageSuperAdmins";
import Kanonismoi from "@/components/Kanonismoi.vue";
// import {activeReserve} from "@/config/menuopts";

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/validate-announcement-me',
      name: 'validate-announcement-me',
      component: ValidateAnnouncementME,
      meta: {
        title: 'Επικύρωση Ανακοίνωσης ΜΕ',
        requiresAuth: true
      }
    },
    {
      path: '/admin-dashboard',
      name: 'admin-dashboard',
      component: AdminDashboard,
      meta: {
        title: 'Πίνακας Διαχειριστή',
        requiresAuth: true
      }
    },
    {
      path: '/manage-all-admins',
      name: 'manage-all-admins',
      component: ManageSuperAdmins,
      meta: {
        title: 'Διαχειριστές Εφαρμογής',
        requiresAuth: true
      }
    },
    {
      path: '/validate-announcement-deps',
      name: 'validate-announcement-deps',
      component: ValidateAnnouncementDEPS,
      meta: {
        title: 'Επικύρωση Ανακοίνωσης ΔΕΠΣ',
        requiresAuth: true
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        title: 'Συχνές Ερωτήσεις'
      }
    },

    {
      path: '/reserve',
      name: 'reserve',
      component: ΑctiveReserve,

      meta: {
        title: 'Ενεργή Εφεδρεία',
        requiresAuth: true
      }
    },
    {
      path: '/teams',
      name: 'ManageTeams',
      component: ManageTeams,
      meta: {
        title: 'Επεξεργασία Ομάδων',
        requiresAuth: true
      }
    },
    {
      path: '/create-team',
      name: 'CreateTeamView',
      component: CreateTeamView,
      meta: {
        title: 'Δημιουργία Ομάδας',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Σύνδεση'
      },
      beforeEnter: (to, from, next) => {
        if (VueCookies.get('notAdmin')) {
          VueCookies.remove('notAdmin');
          store.state.notAdmin = true;
        }else{
          store.state.notAdmin = false;
        }
        if (!VueCookies.get("token")) {
          next()
        }
        else {
          store.dispatch('getUserInfo')
              .then(() => {
                if (store.getters.userRole === 'ROLE_USER' || store.getters.userRole === 'ROLE_MANAGER' || store.getters.userRole === 'ROLE_SXHMATISMOS') {
                  next('/user-dashboard')
                }
                else if (store.getters.userRole === 'ROLE_ADMIN' || store.getters.userRole === 'ROLE_SUPERADMIN') {
                  next('/admin-dashboard')
                }
                else if(store.getters.userRole === 'ROLE_UNREGISTERED') {
                  next('/validate')
                }

              })
        }
      }
    },
    {
      path: '/view_me_announcement/:id',
      name: 'view_me_announcement',
      component: ViewAnnouncement,
      meta: {
        title: 'Εμφάνιση Ανακοινώσεων ΜΕ',
        requiresAuth: true
      }
    },
    {
      path: '/view_des_announcement/:id',
      name: 'view_des_announcement',
      component: ViewAnnouncement,
      meta: {
        title: 'Εμφάνιση Ανακοινώσεων ΔΕΠΕΣ',
        requiresAuth: true
      }
    },
    {
      path: '/user-dashboard',
      name: 'user-dashboard',
      component: UserDashboard,
      meta: {
        title: 'Αρχική σελίδα',
        requiresAuth: true
      },
    },
    {
      path: '/register-me',
      name: 'register-me',
      component: RegisterMe,
      props: { isMe: true },
      meta: {
        title: 'Δημιουργία Διαχειριστή ΜΕ',
        requiresAuth: true
      }
    },
    {
      path: '/register-sxhmatismos',
      name: 'register-sxhmatismos',
      component: RegisterSxhmatismos,
      props: { isMe: true },
      meta: {
        title: 'Δημιουργία Διαχειριστή Σχηματισμού',
        requiresAuth: true
      }
    },
    {
      path: '/register-des',
      name: 'register-des',
      component: RegisterDes,
      props: { isMe: false },
      meta: {
        title: 'Δημιουργία Διαχειριστή ΔΕΠΕΘ',
        requiresAuth: true
      }
    },
    {
      path: '/validate',
      name: 'validate',
      component: Validate,
      meta: {
        title: 'Εγγραφή Χρήστη'
      }
    },
    {
      path: '/user-details',
      name: 'user-details',
      component: UserDetails,
      meta: {
        title: 'Ατομικά Στοιχεία',
        requiresAuth: true
      }
    },
    {
      path: '/des-users',
      name: 'des-users',
      component: ShowAdminsDES,
      meta: {
        title: 'Διαχειριστές ΔΕΠΕΘ',
        requiresAuth: true
      }
    },
    {
      path: '/me-users',
      name: 'me-users',
      component: ShowAdminsME,
      meta: {
        title: 'Διαχειριστές ΜΕ',
        requiresAuth: true
      }
    },
    {
      path: '/deps-users',
      name: 'deps-users',
      component: ShowAdminsDEPS,
      meta: {
        title: 'Διαχειριστές ΔΕΠΣ',
        requiresAuth: true
      }
    },
    {
      path: '/logout/success',
      name: 'logout',
      component: Logout,
      meta: {
        title: 'Αποσύνδεση',
        requiresAuth: true
      }
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: Announcements,
      meta: {
        title: 'Ανακοινώσεις',
        requiresAuth: true
      }
    },
    {
      path: '/meannouncements',
      name: 'meannouncements',
      component: Announcements,
      meta: {
        title: 'Ανακοινώσεις',
        requiresAuth: true
      }
    },
    {
      path: '/desannouncements',
      name: 'desannouncements',
      component: Announcements,
      meta: {
        title: 'ΔΕΠΕΘ Ανακοινώσεις',
        requiresAuth: true
      }
    },
    {
      path: '/depsannouncements',
      name: 'depsannouncements',
      component: Announcements,
      meta: {
        title: 'ΔΕΠΣ Ανακοινώσεις',
        requiresAuth: true
      }
    },
    {
      path: '/omadesannouncements',
      name: 'omadesannouncements',
      component: Announcements,
      meta: {
        title: 'Ανακοινώσεις Ομάδων',
        requiresAuth: true
      }
    },
    {
      path: '/user-details-admin',
      name: 'user-details-admin',
      component: UserDetailsAdmin,
      meta: {
        title: 'Διαχείριση Εφέδρων',
        requiresAuth: true
      }
    },
    {
      path: '/contact-me',
      name: 'contact-me',
      component: ContactME,
      meta: {
        title: 'Επικοινωνία με ΜΕ',
        requiresAuth: true,
      }
    },
    {
      path: '/create-announcement',
      name: 'create-announcement',
      component: CreateAnnouncement,
      meta: {
        title: 'Δημιουργία Ανακοίνωσης',
        requiresAuth: true
      }
    },
    {
      path: '/generate-validation',
      name: 'generate-validation',
      component: GenerateValidation,
      meta: {
        requiresAuth: true,
        title: 'Εκτύπωση Βεβαίωσης'
      }
    },
    {
      path: '/generate-efp',
      name: 'generate-efp',
      component: GenerateEFP,
      meta: {
        requiresAuth: true,
        title: 'Εκτύπωση Ειδικού Φύλλου Πορείας'
      }
    },
   /* {
      path: '/unverified-users',
      name: 'unverified-users',
      component: UnverifiedUsers,
      meta: {
        requiresAuth: true,
        title: 'Μη επιβεβαιωμένοι χρήστες'
      }
    },*/
    /*{
      path: '/efp-users',
      name: 'efp-users',
      component: EfpUsers,
      meta: {
        requiresAuth: true,
        title: 'Χρήστες με ΕΦΠ'
      }
    },*/
    {
      path: '/changes-table',
      name: 'changes-table',
      component: ChangesTable,
      meta: {
        requiresAuth: true,
        title: 'Πίνακας Μεταβολών'
      }
    },
    {
      path: '/generate-efp',
      name: 'generate-efp',
      component: GenerateEFP,
      meta: {
        requiresAuth: true,
        title: 'Εκτύπωση Ειδικού Φύλλου Πορείας'
      }
    },
    /*{
      path: '/unverified-users',
      name: 'unverified-users',
      component: UnverifiedUsers,
      meta: {
        requiresAuth: true,
        title: 'Μη επιβεβαιωμένοι χρήστες'
      }
    }, */ 
    {
      path: '/data-privacy',
      name: 'data-privacy',
      component: DataPrivacy,
      meta: {
        title: 'Πολιτική Απορρήτου'
      }
    },
    {
      path: '/kanonismoi',
      name: 'kanonismoi',
        component: Kanonismoi,
      meta: {
        title: 'Στρατιωτικοί Κανονισμοί'
      }
    },
    // {
    //   path: '/edit-history',
    //   name: 'edit-history',
    //   component: EditHistory,
    //   meta: {
    //     title: 'Ιστορικό Εκδόσεων'
    //   }
    // },
    {
      path: '/diav-import',
      name: 'diav-import',
      component: DiavImportView,
      meta: {
        title: 'Εισαγωγή δεδομένων'
      }
    },
    {
      path: '*',
      component: Nice404,
      meta: {
        title: 'Η σελίδα δεν βρέθηκε'
      }
    }
  ]
});


router.beforeEach((to, from, next) =>
{
  document.title = to.meta.title || 'Αρχική σελίδα';

  let cookies = VueCookies.get("token")
  if(cookies) {
    store.commit('set_token', cookies)
  }

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
    } else {
      next('/login');
    }
  } else {
    if (to.path === '/login' && to.query.token && !store.getters.isLoggedIn) 
      return next({name:'signup', query: { token: to.query.token } });
    next();
  }
});

export default router;
